<script>
  import ProjectsTable from "../components/projectsTable.svelte";
  import PageContainer from "../components/shared/PageContainer.svelte";

  let el1;

  const mountProjectsCount = async () => {
    const module = await import("App/ProjectDetails/count");
    const ProjectsCount = module.default;

    if (el1) {
      el1.innerHTML = "";
      new ProjectsCount({
        target: el1,
      });
    }
  };

  mountProjectsCount();
</script>

<PageContainer>
  <div class="grid gap-3 w-full">
    <div class="uimodule" bind:this={el1} />
    <div class="uimodule">
      <ProjectsTable />
    </div>
  </div>
</PageContainer>
